import React, { useState } from "react";
import { Chart } from "chart.js/auto"
import { CategoryScale } from "chart.js";
import { Pie } from "react-chartjs-2";
import { displayMessage } from "../../services/helper";

import ListPatientsBySection from '../../components/modals/ListPatientsBySection'

Chart.register(CategoryScale);

export default function PatientScoreChart({ patientScoreChart }) {
    const [patientsByInterval, setPatientsByInterval] = useState([])
    const [isModalPatientsBySectionOpen, setIsModalPatientsBySectionOpen] = useState(false)

    const findPatientsByInterval = (interval) => {
        let id = 0
        let patientsByStars = []
        for (let key in patientScoreChart) {
            if (key == interval) {
                for (let patient_id in patientScoreChart[key]) {
                    patientsByStars.push(patientScoreChart[key][patient_id])
                }
                id++
            }
        }
        setPatientsByInterval(patientsByStars)
    }

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        type: 'pie',
        responsive: true,
        backgroundColor: [
            "#f38b4a",
            "#3E95CD",
            "#ff8397",
            '#C45850',
            '#8E5EA2',
            '#3CBA9F'
        ],
        onClick: (event, elements) => {
            setIsModalPatientsBySectionOpen(true)
            findPatientsByInterval(event.chart.tooltip.title[0])
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: (data) => {
                        const dataset = data.dataset;
                        const currentValue = dataset.data[data.dataIndex];
                        let total = dataset.data.reduce((total, current) => total + current);

                        const percentage = (currentValue / total * 100).toFixed(0);
                        return ` ${displayMessage('PATIENTS')}:${currentValue}  (${percentage}%)`;
                    },
                }
            }
        }
    };

    const data = {
        labels: patientScoreChart ? Object.keys(patientScoreChart) : [],
        datasets: [{
            label: displayMessage('STARS_AVARGE'),
            data: patientScoreChart ? Object.values(patientScoreChart).map(value => value.length) : []
        }]
    };

    return (
        <>
            {data && (
                <Pie
                    data={data}
                    width={300}
                    height={300}
                    options={options}
                    style={{ maxHeight: 300 }}
                />
            )}

            <ListPatientsBySection
                patientsByInterval={patientsByInterval}
                isModalPatientsBySectionOpen={isModalPatientsBySectionOpen}
                setIsModalPatientsBySectionOpen={setIsModalPatientsBySectionOpen}
            />
        </>
    )
}